import Overview from "@/views/App/CoachingOverview/Overview.vue";

import NewAndActiveList from "@/views/App/CoachingOverview/PrivateCoaching/NewAndActive/List.vue";
import FinishedList from "@/views/App/CoachingOverview/PrivateCoaching/Finished/List.vue";
import ArchivedList from "@/views/App/CoachingOverview/PrivateCoaching/Archived/List.vue";
import InquiryList from "@/views/App/CoachingOverview/PrivateCoaching/Inquiry/List.vue";

import GroupNewAndActiveList from "@/views/App/CoachingOverview/GroupCoaching/NewAndActive/List.vue";
import GroupFinishedList from "@/views/App/CoachingOverview/GroupCoaching/Finished/List.vue";
import GroupArchivedList from "@/views/App/CoachingOverview/GroupCoaching/Archived/List.vue";

import SocioTherapyNewAndActiveList from "@/views/App/CoachingOverview/SocioTherapyCoaching/NewAndActive/List.vue";
import SocioTherapyFinishedList from "@/views/App/CoachingOverview/SocioTherapyCoaching/Finished/List.vue";
import SocioTherapyArchivedList from "@/views/App/CoachingOverview/SocioTherapyCoaching/Archived/List.vue";

import AssistedLivingNewAndActiveList from "@/views/App/CoachingOverview/AssistedLivingCoaching/NewAndActive/List.vue";
import AssistedLivingFinishedList from "@/views/App/CoachingOverview/AssistedLivingCoaching/Finished/List.vue";
import AssistedLivingArchivedList from "@/views/App/CoachingOverview/AssistedLivingCoaching/Archived/List.vue";

import CaseManagementNewAndActiveList from "@/views/App/CoachingOverview/CaseManagementCoaching/NewAndActive/List.vue";
import CaseManagementFinishedList from "@/views/App/CoachingOverview/CaseManagementCoaching/Finished/List.vue";
import CaseManagementArchivedList from "@/views/App/CoachingOverview/CaseManagementCoaching/Archived/List.vue";

import PrivateLearningCoachingNewAndActiveList from "@/views/App/CoachingOverview/PrivateLearningCoaching/NewAndActive/List.vue";
import PrivateLearningCoachingFinishedList from "@/views/App/CoachingOverview/PrivateLearningCoaching/Finished/List.vue";
import PrivateLearningCoachingArchivedList from "@/views/App/CoachingOverview/PrivateLearningCoaching/Archived/List.vue";

const routesCoachingOverview = [
    {
        path: '',
        name: 'coachingOverview',
        component: Overview
    },

    // Private coaching
    {
        path: 'private-coaching/new-and-active',
        name: 'privateCoachingNewAndActiveList',
        component: NewAndActiveList
    },
    {
        path: 'private-coaching/finished',
        name: 'privateCoachingFinishedList',
        component: FinishedList
    },
    {
        path: 'private-coaching/archived',
        name: 'privateCoachingArchivedList',
        component: ArchivedList
    },
    {
        path: 'private-coaching/inquiry-list',
        name: 'privateCoachingInquiryOverviewList',
        component: InquiryList
    },

    // Group coaching
    {
        path: 'group-coaching/new-and-active',
        name: 'groupCoachingNewAndActiveList',
        component: GroupNewAndActiveList
    },
    {
        path: 'group-coaching/finished',
        name: 'groupCoachingFinishedList',
        component: GroupFinishedList
    },
    {
        path: 'group-coaching/archived',
        name: 'groupCoachingArchivedList',
        component: GroupArchivedList
    },

    // Socio therapy coaching
    {
        path: 'socio-therapy-coaching/new-and-active',
        name: 'socioTherapyCoachingNewAndActiveList',
        component: SocioTherapyNewAndActiveList
    },
    {
        path: 'socio-therapy-coaching/finished',
        name: 'socioTherapyCoachingFinishedList',
        component: SocioTherapyFinishedList
    },
    {
        path: 'socio-therapy-coaching/archived',
        name: 'socioTherapyCoachingArchivedList',
        component: SocioTherapyArchivedList
    },

    // Assisted living coaching
    {
        path: 'assisted-living-coaching/new-and-active',
        name: 'assistedLivingCoachingNewAndActiveList',
        component: AssistedLivingNewAndActiveList
    },
    {
        path: 'assisted-living-coaching/finished',
        name: 'assistedLivingCoachingFinishedList',
        component: AssistedLivingFinishedList
    },
    {
        path: 'assisted-living-coaching/archived',
        name: 'assistedLivingCoachingArchivedList',
        component: AssistedLivingArchivedList
    },

    // Case management coaching
    {
        path: 'case-management-coaching/new-and-active',
        name: 'caseManagementCoachingNewAndActiveList',
        component: CaseManagementNewAndActiveList
    },
    {
        path: 'case-management-coaching/finished',
        name: 'caseManagementCoachingFinishedList',
        component: CaseManagementFinishedList
    },
    {
        path: 'case-management-coaching/archived',
        name: 'caseManagementCoachingArchivedList',
        component: CaseManagementArchivedList
    },

    // Private learning coaching
    {
        path: 'private-learning-coaching/new-and-active',
        name: 'privateLearningCoachingNewAndActiveList',
        component: PrivateLearningCoachingNewAndActiveList
    },
    {
        path: 'private-learning-coaching/finished',
        name: 'privateLearningCoachingFinishedList',
        component: PrivateLearningCoachingFinishedList
    },
    {
        path: 'private-learning-coaching/archived',
        name: 'privateLearningCoachingArchivedList',
        component: PrivateLearningCoachingArchivedList
    },
];

export default routesCoachingOverview;